import './memoSort.css';

import * as React from 'react';
import Constants from 'src/common/Constants';
import Member from 'src/entities/Member';

import Memo from '../../entities/Memo';
import FilterBlackRich from '../../res/img/filter_black_rich.svg';
import SortBlackRich from '../../res/img/sort_black_rich.svg';

interface IProps {
  setSortFunc: any;
  account: Member;
}

interface IState {
  sortMemo: string;
  filterMemo: string;
  loadedTime: number;
}

class MemoSortComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      sortMemo: location.pathname === '/' ? 'deadline' : 'latest',
      filterMemo: location.pathname.includes('search') ? 'all' : 'ongoing',
      loadedTime: Date.now()
    };

    const memoSort =
      this.state.sortMemo === 'deadline'
        ? this.SORT_DEADLINE
        : this.SORT_LATEST;

    const memoFilter = this.FILTER_ONGOING;

    this.props.setSortFunc(memoSort, memoFilter);
  }

  SORT_LATEST = (a: Memo, b: Memo) => (a.created > b.created ? -1 : 1);
  SORT_DEADLINE = (a: Memo, b: Memo) => {
    if (a.deadline <= 0) {
      return 1;
    }

    if (b.deadline <= 0) {
      return -1;
    }

    return a.deadline < b.deadline ? -1 : 1;
  };
  SORT_COMMENT = (a: Memo, b: Memo) => {
    const acomments = a.comments.filter(
      comment => comment.created < this.state.loadedTime
    );
    const bcomments = b.comments.filter(
      comment => comment.created < this.state.loadedTime
    );
    if (acomments.length === 0) {
      return 1;
    }
    if (bcomments.length === 0) {
      return -1;
    }

    return acomments.reduce((aa, ab) => (aa.created > ab.created ? aa : ab))
      .created >
      bcomments.reduce((ba, bb) => (ba.created > bb.created ? ba : bb)).created
      ? -1
      : 1;
  };

  FILTER_ALL = (a: Memo) => true;

  FILTER_CALLOUT = (a: Memo) =>
    a.completed !== true &&
    a.comments.filter(comment => comment.callout).length > 0
      ? true
      : false;

  FILTER_ONGOING = (a: Memo) =>
    a.reportStatus !== Constants.REPORT_FINAL && a.completed !== true
      ? true
      : false;

  FILTER_REPORT_FINAL = (a: Memo) =>
    a.completed !== true && a.reportStatus === Constants.REPORT_FINAL
      ? true
      : false;

  FILTER_PERFORMER = (a: Memo) =>
    a.completed !== true && a.performers.includes(this.props.account.id)
      ? true
      : false;

  FILTER_REPORTER = (a: Memo) =>
    a.completed !== true && a.reporters.includes(this.props.account.id)
      ? true
      : false;

  FILTER_WATCHER = (a: Memo) =>
    a.completed !== true && a.watchers.includes(this.props.account.id)
      ? true
      : false;

  FILTER_VIOLATION = (memo: Memo) =>
    !memo.tags.includes('督促不要') &&
    memo.reportStatus !== Constants.REPORT_FINAL &&
    memo.completed !== true &&
    ((memo.tags.includes('四半期報告') &&
      memo.updated + 3 * 31 * 24 * 60 * 60 * 1000 < Date.now()) ||
      (memo.tags.includes('毎月報告') &&
        memo.updated + 31 * 24 * 60 * 60 * 1000 < Date.now()) ||
      (memo.tags.includes('月2回報告') &&
        memo.updated + 14 * 24 * 60 * 60 * 1000 < Date.now()) ||
      (memo.tags.includes('毎週報告') &&
        memo.updated + 7 * 24 * 60 * 60 * 1000 < Date.now()) ||
      (memo.tags.includes('毎日報告') &&
        memo.updated + 3 * 24 * 60 * 60 * 1000 < Date.now()) ||
      (!memo.tags.includes('四半期報告') &&
        !memo.tags.includes('毎月報告') &&
        !memo.tags.includes('月2回報告') &&
        !memo.tags.includes('毎週報告') &&
        !memo.tags.includes('毎日報告') &&
        memo.updated + 7 * 24 * 60 * 60 * 1000 < Date.now()) ||
      (!memo.tags.includes('四半期報告') &&
        !memo.tags.includes('毎月報告') &&
        !memo.tags.includes('月2回報告') &&
        !memo.tags.includes('毎週報告') &&
        !memo.tags.includes('毎日報告') &&
        memo.comments.length === 0 &&
        memo.created + 3 * 24 * 60 * 60 * 1000 < Date.now()) ||
      (!memo.tags.includes('四半期報告') &&
        !memo.tags.includes('毎月報告') &&
        !memo.tags.includes('月2回報告') &&
        !memo.tags.includes('毎週報告') &&
        !memo.tags.includes('毎日報告') &&
        memo.deadline > 0 &&
        memo.deadline < Date.now()));

  FILTER_REGULAR = (memo: Memo) =>
    (memo.tags.includes('四半期報告') ||
      memo.tags.includes('毎月報告') ||
      memo.tags.includes('月2回報告') ||
      memo.tags.includes('毎週報告') ||
      memo.tags.includes('毎日報告')) &&
    memo.reportStatus !== Constants.REPORT_FINAL &&
    memo.completed !== true;

  render() {
    return (
      <div id="SortAndFilter">
        <div id="MemoFilter">
          <img src={FilterBlackRich} />
          <select
            onChange={this.changeSortAndFilter.bind(this, 'filter')}
            defaultValue={this.state.filterMemo}
          >
            <option value="all">すべて</option>
            <option value="reporter">自分が報告</option>
            <option value="performer">自分が実行</option>
            <option value="watcher">自分が注目</option>
            {/* <option value="callout">読み上げ</option> */}
            <option value="report_final">最終報告</option>
            <option value="ongoing">進行中</option>
            <option value="violation">ルール違反</option>
            <option value="regular">定期報告</option>
          </select>
        </div>

        <div id="MemoSort">
          <img src={SortBlackRich} />
          <select
            onChange={this.changeSortAndFilter.bind(this, 'sort')}
            defaultValue={this.state.sortMemo}
          >
            <option value="latest">新しい順</option>
            <option value="comment">コメント順</option>
            <option value="deadline">次の報告日順</option>
          </select>
        </div>
      </div>
    );
  }

  changeSortAndFilter(type: string, e: any) {
    let sortCurrent: any;
    let filterCurrent: any;
    if (type === 'sort') {
      this.setState({
        sortMemo: e.target.value
      });
      sortCurrent = e.target.value;
      filterCurrent = this.state.filterMemo;
    }

    if (type === 'filter') {
      this.setState({
        filterMemo: e.target.value
      });
      sortCurrent = this.state.sortMemo;
      filterCurrent = e.target.value;
    }

    let memoSort: any;
    if (sortCurrent === 'latest') {
      memoSort = this.SORT_LATEST;
    } else if (sortCurrent === 'comment') {
      memoSort = this.SORT_COMMENT;
    } else if (sortCurrent === 'deadline') {
      memoSort = this.SORT_DEADLINE;
    }

    let memoFilter: any;
    if (filterCurrent === 'all') {
      memoFilter = this.FILTER_ALL;
    } else if (filterCurrent === 'callout') {
      memoFilter = this.FILTER_CALLOUT;
    } else if (filterCurrent === 'report_final') {
      memoFilter = this.FILTER_REPORT_FINAL;
    } else if (filterCurrent === 'ongoing') {
      memoFilter = this.FILTER_ONGOING;
    } else if (filterCurrent === 'watcher') {
      memoFilter = this.FILTER_WATCHER;
    } else if (filterCurrent === 'performer') {
      memoFilter = this.FILTER_PERFORMER;
    } else if (filterCurrent === 'reporter') {
      memoFilter = this.FILTER_REPORTER;
    } else if (filterCurrent === 'violation') {
      memoFilter = this.FILTER_VIOLATION;
    } else if (filterCurrent === 'regular') {
      memoFilter = this.FILTER_REGULAR;
    }

    this.props.setSortFunc(memoSort, memoFilter);
  }
}

export default MemoSortComponent;



// WEBPACK FOOTER //
// ./src/components/Navigation/memoSort.tsx